import type { LocaleDictionary } from "@/i18n/types";

const nsSideNavEN = {
  global: {
    ariaLabel: "Main Menu",
    openButtonAriaLabel: "Expand Main Menu",
    closeButtonAriaLabel: "Collapse Main Menu",
    openLocalButtonAriaLabel: "Expand Sub Menu",
  },
  local: {
    ariaLabel: "Sub Menu",
    closeButtonAriaLabel: "Collapse Sub Menu",
  },
  settings: {
    ariaLabel: "Settings Menu",
    closeButtonAriaLabel: "Collapse Settings Menu",
  },
  item: {
    backToOrganization: "Back to Organization",
    versionList: "Version List",
    versionComparison: "Version Comparison",
    versions: "Versions",
    sheets: "Sheets",
    views: "Views",
    organizationSetting: "Organization Settings",
    algorithmVersions: "Algorithm Versions",
    tadSheets: "Time-accumulated Data Sheets",
    frontendAddons: "Front-end Add-ons",
    connectMasters: "Connect Masters",
    endpointAddonMasters: "Endpoint Addon Masters",
    back: "Back",
  },
  versionSummary: {
    detailLink: "View Version Summary",
    preparing: "Preparing data... Please refresh in a few minutes.",
    empty: "No summary available.",
  },
  addonLoadError: "Failed to load front-end add-ons.",
  sortError: {
    sheet: "Failed to sort sheets.",
    view: "Failed to sort views.",
  },
} satisfies LocaleDictionary;

export default nsSideNavEN;
